/**
 * API Configuration
 * Centralized backend API base URL
 */

// POS API (GCP e2-micro) — set VITE_POS_API_URL in .env
export const API_BASE_URL = import.meta.env.VITE_POS_API_URL as string
export const HSN_CDN_URL = import.meta.env.VITE_HSN_CDN_URL?.trim() || ''
